export const orderStatusOutline =
  'https://res.cloudinary.com/foodlytech/image/upload/f_auto/v1594280204/foodly/web/newOrderStatusOutline.png'
export const orderStatusFill =
  'https://res.cloudinary.com/foodlytech/image/upload/f_auto/v1594280204/foodly/web/newOrderStatusFill.png'

export const deliveryOrderStatusOutline =
  'https://res.cloudinary.com/foodlytech/image/upload/f_auto/v1592039141/foodly/web/deliveryOrderStatusOutline.png'
export const deliveryOrderStatusFill =
  'https://res.cloudinary.com/foodlytech/image/upload/f_auto/v1592039141/foodly/web/deliveryOrderStatusFill.png'
